import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserCacheLocation, PublicClientApplication } from '@azure/msal-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { MSAL_INSTANCE } from './app/core/auth/msal-instance.token';
import { isMsalChildFrameResponse } from './app/core/auth/msal-child-frame';
import { environment } from './environments/environment';

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.entra.clientId,
    authority: environment.entra.authority,
    redirectUri: environment.entra.redirectUri,
    postLogoutRedirectUri: environment.entra.postLogoutRedirectUri
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage
  }
});

const bootstrap = async () => {
  await msalInstance.initialize();
  const redirectResult = await msalInstance.handleRedirectPromise();
  if (redirectResult?.account) {
    msalInstance.setActiveAccount(redirectResult.account);
  }

  return bootstrapApplication(App, {
    ...appConfig,
    providers: [
      ...(appConfig.providers ?? []),
      { provide: MSAL_INSTANCE, useValue: msalInstance }
    ]
  });
};

// MSAL silent-renewal iframes and popups land on redirectUri (this app). Hand the auth
// response back to the main frame instead of bootstrapping a nested app instance.
if (isMsalChildFrameResponse(window)) {
  import('@azure/msal-browser/redirect-bridge')
    .then(({ broadcastResponseToMainFrame }) => broadcastResponseToMainFrame())
    .catch((err) => console.error('MSAL redirect bridge failed', err));
} else {
  bootstrap().catch((err) => console.error(err));
}
